import React from 'react';
import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Activity = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Activity;
